export default {"src":"/_next/static/media/0xf97f4df75117a78c1a5a0dbb814af92458539fb4.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};